//Add Admin
export const ADD_ADMIN ="ADD_ADMIN"
export const ADD_ADMIN_SUCCESS = "ADD_ADMIN_SUCCESS"
export const ADD_ADMIN_FAIL = "ADD_ADMIN_FAIL"
export const ADMIN_LOADING ="ADMIN_LOADING"
